import { createApi } from "../axiosInstance";
import { createComplianceApi } from "../shared/complianceApiFactory";

// Compliance is owned by the central FPO service. MyBusiness only identifies its
// tenant type; the authenticated user identifies the actual company.
const api = createApi("myFPO");

export const {
  getPANBusiness,
  getAllPANBusiness,
  addPANBusiness,
  getPANBusinessById,
  updatePANBusiness,
  deletePANBusiness,
  updatePanBusinessStatus,
  downloadPANRegistration,
  getPANIndividual,
  getAllPANIndividual,
  getMyPANIndividual,
  addPANIndividual,
  getPANIndividualById,
  updatePANIndividual,
  deletePANIndividual,
  updatePanIndividualStatus,
  getFPCById,
  fpcRegistration,
  getAllFpoFpcRegistrations,
  getFPC,
  updateFpoFpcStatus,
  updateFPCRegistration,
  deleteFPCCompany,
  registerIso,
  getIsoRegistration,
  getAllIsoRegistration,
  getMyIsoRegistration,
  getIsoRegistrationById,
  updateIsoRegistration,
  updateIsoStatus,
  deleteIsoRegistration,
  registerIec,
  getIecRegistrations,
  getAllIecRegistrations,
  getMyIecRegistrations,
  getIecRegistrationById,
  updateIecRegistration,
  updateIecStatus,
  deleteIecRegistration,
  getMSMEByFpoId,
  getAllMSME,
  getMyMSME,
  msmeRegistration,
  getMSMEById,
  updateMSMERegistration,
  updateMSMEStatus,
  deleteMSME,
  registerGst,
  getGstRegistrations,
  getAllGstRegistrations,
  getMyGstRegistrations,
  getGstRegistrationById,
  updateGstRegistration,
  updateGstStatus,
  deleteGstRegistration,
  registerCompany,
  getCompanyRegistrations,
  getAllCompanyRegistrations,
  getCompanyRegistrationById,
  updateCompanyRegistration,
  updateCompanyStatus,
  deleteCompanyRegistration,
  registerTradeLicense,
  getTradeLicenses,
  getAllTradeLicenses,
  getMyTradeLicenses,
  getTradeLicenseById,
  updateTradeLicense,
  updateTradeLicensesStatus,
  deleteTradeLicense,
  registerLabourLicense,
  getLabourLicenses,
  getAllLabourLicenses,
  getMyLabourLicenses,
  getLabourLicenseById,
  updateLabourLicense,
  updateLabourLicensesStatus,
  deleteLabourLicense,
  downloadLabourLicense,
  registerShopsEstablishment,
  getShopsEstablishment,
  getAllShopsEstablishment,
  getMyShopsEstablishment,
  getShopsEstablishmentById,
  updateShopsEstablishment,
  updateShopsEstablishmentStatus,
  deleteShopsEstablishment,
  registerFSSAI,
  getFSSAIRegistrations,
  getAllFSSAIRegistrations,
  getMyFSSAIRegistrations,
  getFSSAIRegistrationById,
  updateFSSAIRegistration,
  updateFSSAIStatus,
  deleteFSSAIRegistration,
} = createComplianceApi(api, "MY_BUSINESS");
